import React from 'react'

import './index.css'

const TitleLogo = (({title})=>(
	<div className="title__logo">
		<h2 dangerouslySetInnerHTML={{__html: title}}></h2>
	</div>
))

export default TitleLogo


// WEBPACK FOOTER //
// ./src/Components/TitleLogo/index.js